declare let Hammer: any;
export let pcGestureHandle = (reader: any, eventObject: any, fileType: string) => {
  let type: string,
    currentV0: number,
    distanceX: number,
    distanceY: number,
    initScale: number,
    tempDeltaY: number,
    tempDeltaX: number,
    judgeMoveId: number = 0, // 0：代表未触碰左侧和右侧；1：代表未触碰左侧；2：代表未触碰右侧
    hammerTest = new Hammer(eventObject),
    tempCenter: number = 0;
  hammerTest.get('pan').set({ direction: Hammer.DIRECTION_ALL });
  hammerTest.get('pinch').set({ enable: true });
  let actionDefault;
  if (fileType === 'ppt') {
    actionDefault = 'hammer.input panup pandown panleft panright panstart panmove panend pancancel tap press';
  } else {
    actionDefault = 'hammer.input panup pandown panleft panright panstart panmove panend pancancel pinchstart pinchmove pinchend tap press';
  }
  hammerTest.on(actionDefault, (ev: any) => {
    if (ev.pointerType === 'mouse') return
    switch (ev.type) {
      case 'hammer.input':
        currentV0 = 0;
        break;
      case 'panup':
        type = 'panup';
        break;
      case 'pandown':
        type = 'pandown';
        break;
      case 'panleft':
        type = 'panleft';
        break;
      case 'panright':
        type = 'panright';
        break;
      case 'panstart':
        if (reader.isShow) return
        type = 'panstart';
        tempDeltaX = 0;
        tempDeltaY = 0;
        judgeMoveId = reader.MoibleJudgeMove(ev.srcEvent);
        // 开始拖动的时候，让淡出效果立马消失
        $('#wpreader-footer').stop().fadeOut();
        break;
      case 'panmove':
        if (reader.isShow) return
        type = 'panmove';
        if (judgeMoveId === 0) { // 即复制按钮出现时，未做拖动选取动作，所以可以滚动
          // y方向滚动
          reader.SwiperMobleScroll((ev.deltaY - tempDeltaY));
          // x方向滚动
          if (fileType === 'word') {
            $('#dcs-wpreader-canvaswrapper').scrollLeft($('#dcs-wpreader-canvaswrapper').scrollLeft() - (ev.deltaX - tempDeltaX));
          } else if (fileType === 'ppt') {
            $('#dcs-pgreader-canvaswrapper').scrollLeft($('#dcs-pgreader-canvaswrapper').scrollLeft() - (ev.deltaX - tempDeltaX));
          }
          tempDeltaX = ev.deltaX;
          tempDeltaY = ev.deltaY;
          // 让移动端底部显示页码标志
          if ($('#wpreader-footer').css('display') == 'none') {
            // top 值重新赋值
            if ($('#wpreader-footer').css('top') === 'auto') {
              $('#wpreader-footer').css({ 'top': window.innerHeight - 60 });
            }
            $('#wpreader-footer').fadeIn(100);
          }
        } else if (judgeMoveId === 1) { // 即复制按钮出现时，拖动左侧选取动作，所以禁止滚动，然后选取变化
          reader.MobileDoClick(ev.srcEvent, reader.caret1);
          $('#copyInput').hide();
        } else if (judgeMoveId === 2) { // 即复制按钮出现时，拖动右侧选取动作，所以禁止滚动，然后选取变化
          reader.MobileDoClick(ev.srcEvent, reader.caret2);
          $('#copyInput').hide();
        }
        reader.MobilePaintSelection('#357EC7');
        break;
      case 'panend':
        if (reader.isShow) return
        let velocity: number = Math.abs(ev.velocity);
        if (velocity == 0) return;
        let a: number = -0.003; //滚动的摩擦系数
        currentV0 = velocity;
        if (currentV0 >= 0) timeMeterHandle(a);
        // 选取结束的时候，复制按钮重现
        if (judgeMoveId === 1 || judgeMoveId === 2) {
          $('#copyInput').show();
        }
        // 滑动结束的时候，使底部页码淡出
        $('#wpreader-footer').fadeOut(4000);
        break;
      case 'pancancel':
        type = 'pancancel';
        break;
      case 'tap':
        // 选取结束的时候，复制按钮重现
        if (judgeMoveId === 1 || judgeMoveId === 2) {
          $('#copyInput').show();
        } else {
          reader.removeMobileCeret();
        }
        break;
      case 'pinchstart':
        if (fileType === 'word') {
          initScale = reader.zoom || 1;
        } else if (fileType === 'ppt') {
          initScale = reader.currentZoom || 1;
        }
        type = 'pinch'
        tempCenter = ev.center.x
        break;
      case 'pinchmove':
        reader.removeMobileCeret()
        let zoom
        if (reader.isShow) {
          if (ev.scale > 1.3 || ev.scale < 0.7) {
            let scale
            if (ev.scale > 1) {
              scale = ev.scale - 0.15
            } else {
              scale = ev.scale + 0.15
            }
            if (fileType === 'word') {
              if (initScale * scale <= reader.mobileInitZoom) {
                zoom = reader.mobileInitZoom;
              } else if (initScale * scale >= reader.mobileInitZoom * 5) {
                zoom = reader.mobileInitZoom * 5;
              } else {
                zoom = initScale * scale;
              }
            } else if (fileType === 'ppt') {
              if (scale * initScale <= 1) {
                zoom = 1;
              } else if (scale * initScale >= 5) {
                zoom = 5;
              } else {
                zoom = initScale * scale;
              }
            }
            reader.changeTab(0, zoom)
            if (fileType === 'word' && zoom !== reader.mobileInitZoom * 5) {
              $('#dcs-wpreader-canvaswrapper').scrollLeft(tempCenter / $('#dcs-wpreader-canvaswrapper').width() * reader.canvas.width / 2 - tempCenter);
            } else if (fileType === 'ppt' && zoom !== reader.mobileInitZoom * 5) {
              $('#dcs-pgreader-canvaswrapper').scrollLeft(tempCenter / $('#dcs-wpreader-canvaswrapper').width() * reader.canvas.width / 2 - tempCenter);
            }
          } else {
            // x方向滚动
            if (fileType === 'word') {
              $('#dcs-wpreader-canvaswrapper').scrollLeft($('#dcs-wpreader-canvaswrapper').scrollLeft() - (ev.center.x - tempCenter));
            } else if (fileType === 'ppt') {
              $('#dcs-pgreader-canvaswrapper').scrollLeft($('#dcs-pgreader-canvaswrapper').scrollLeft() - (ev.center.x - tempCenter));
            }
            tempCenter = ev.center.x;
            reader.signMove()
          }
        } else {
          if (ev.scale > 1.2 || ev.scale < 0.8) {
            if (fileType === 'word') {
              if (initScale * ev.scale <= reader.mobileInitZoom) {
                zoom = reader.mobileInitZoom;
              } else if (initScale * ev.scale >= reader.mobileInitZoom * 5) {
                zoom = reader.mobileInitZoom * 5;
              } else {
                zoom = initScale * ev.scale;
              }
            } else if (fileType === 'ppt') {
              if (ev.scale * initScale <= 1) {
                zoom = 1;
              } else if (ev.scale * initScale >= 5) {
                zoom = 5;
              } else {
                zoom = initScale * ev.scale;
              }
            }
            reader.changeTab(0, zoom)
            if (fileType === 'word' && zoom !== reader.mobileInitZoom * 5) {
              $('#dcs-wpreader-canvaswrapper').scrollLeft(tempCenter / $('#dcs-wpreader-canvaswrapper').width() * reader.canvas.width / 2 - tempCenter);
            } else if (fileType === 'ppt' && zoom !== reader.mobileInitZoom * 5) {
              $('#dcs-pgreader-canvaswrapper').scrollLeft(tempCenter / $('#dcs-wpreader-canvaswrapper').width() * reader.canvas.width / 2 - tempCenter);
            }
          } else {
            if (ev.deltaX - tempDeltaX > 60 || ev.deltaX - tempDeltaX < -60) return
            if (ev.deltaY - tempDeltaY > 60 || ev.deltaY - tempDeltaY < -60) return
            reader.SwiperMobleScroll(ev.deltaY - tempDeltaY);
            // x方向滚动
            if (fileType === 'word') {
              $('#dcs-wpreader-canvaswrapper').scrollLeft($('#dcs-wpreader-canvaswrapper').scrollLeft() - (ev.deltaX - tempDeltaX));
            } else if (fileType === 'ppt') {
              $('#dcs-pgreader-canvaswrapper').scrollLeft($('#dcs-pgreader-canvaswrapper').scrollLeft() - (ev.deltaX - tempDeltaX));
            }
            tempDeltaX = ev.deltaX;
            tempDeltaY = ev.deltaY;
          }
        }
        break;
      case 'pinchend':
        tempDeltaX = ev.deltaX - tempDeltaX;
        tempDeltaY = ev.deltaY - tempDeltaY;
        break
      case 'press':
        // 当防复制参数为true的时候
        if (reader.isCopy) {
          reader.MobileMousedown(ev.srcEvent);
        }
        break;
    }
  })

  //rolling operation 
  function timeMeterHandle(a: number) {
    let time: number = window.setInterval(function () {
      let vt: number = currentV0 + a * 20;
      let pOn: number;
      switch (type) {
        case 'panup':
          pOn = -1;
          break;
        case 'pandown':
          pOn = 1;
          break;
      }
      distanceY = (Math.pow(vt, 2) - Math.pow(currentV0, 2)) / (2 * a) * pOn;
      reader.SwiperMobleScroll(distanceY)
      currentV0 = vt;
      if (currentV0 <= 0) clearInterval(time);
    }, 20);
  };
}